import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Source } from 'types/funding';
import iconAdd from './images/icon-add.svg';
import iconArrow from './images/icon-arrow.svg';
import style from './style.scss';

interface AddBankProps {
    source: Source;
}

const AddBank: FC<AddBankProps> = ({ source }) => {
    const navigate = useNavigate();

    return (
        <div
            className={style.root}
            onClick={event => {
                // 该组件是下拉选择的一个选项，但是不希望出发select的onChange事件而是直接跳转页面
                event.stopPropagation();
                navigate('/profile/bankcards/auth/select-way', { state: { source } });
            }}>
            <img src={iconAdd} alt="add" className={style.add} />
            <div className={style.content}>{__('Add Other Bank Account')}</div>
            <img src={iconArrow} alt="arrow" className={style.arrow} />
        </div>
    );
};

export default AddBank;
